/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type DisableNormalMessageChatReplyMatchSettingInput = {
  roomID: string | number;
};

export type EnableNormalMessageChatReplyMatchSettingInput = {
  roomID: string | number;
};

export type EnableNormalMessageChatReplyMatchSettingMutationVariables = Exact<{
  input: Types.EnableNormalMessageChatReplyMatchSettingInput;
}>;


export type EnableNormalMessageChatReplyMatchSettingMutation = { enableNormalMessageChatReplyMatchSetting: { success: boolean } };

export type DisableNormalMessageChatReplyMatchSettingMutationVariables = Exact<{
  input: Types.DisableNormalMessageChatReplyMatchSettingInput;
}>;


export type DisableNormalMessageChatReplyMatchSettingMutation = { disableNormalMessageChatReplyMatchSetting: { success: boolean } };


export const EnableNormalMessageChatReplyMatchSettingDocument = gql`
    mutation enableNormalMessageChatReplyMatchSetting($input: EnableNormalMessageChatReplyMatchSettingInput!) {
  enableNormalMessageChatReplyMatchSetting(input: $input) {
    success
  }
}
    `;

/**
 * __useEnableNormalMessageChatReplyMatchSettingMutation__
 *
 * To run a mutation, you first call `useEnableNormalMessageChatReplyMatchSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableNormalMessageChatReplyMatchSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableNormalMessageChatReplyMatchSettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEnableNormalMessageChatReplyMatchSettingMutation(options: VueApolloComposable.UseMutationOptions<EnableNormalMessageChatReplyMatchSettingMutation, EnableNormalMessageChatReplyMatchSettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EnableNormalMessageChatReplyMatchSettingMutation, EnableNormalMessageChatReplyMatchSettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EnableNormalMessageChatReplyMatchSettingMutation, EnableNormalMessageChatReplyMatchSettingMutationVariables>(EnableNormalMessageChatReplyMatchSettingDocument, options);
}
export type EnableNormalMessageChatReplyMatchSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EnableNormalMessageChatReplyMatchSettingMutation, EnableNormalMessageChatReplyMatchSettingMutationVariables>;
export const DisableNormalMessageChatReplyMatchSettingDocument = gql`
    mutation disableNormalMessageChatReplyMatchSetting($input: DisableNormalMessageChatReplyMatchSettingInput!) {
  disableNormalMessageChatReplyMatchSetting(input: $input) {
    success
  }
}
    `;

/**
 * __useDisableNormalMessageChatReplyMatchSettingMutation__
 *
 * To run a mutation, you first call `useDisableNormalMessageChatReplyMatchSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableNormalMessageChatReplyMatchSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableNormalMessageChatReplyMatchSettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDisableNormalMessageChatReplyMatchSettingMutation(options: VueApolloComposable.UseMutationOptions<DisableNormalMessageChatReplyMatchSettingMutation, DisableNormalMessageChatReplyMatchSettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DisableNormalMessageChatReplyMatchSettingMutation, DisableNormalMessageChatReplyMatchSettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DisableNormalMessageChatReplyMatchSettingMutation, DisableNormalMessageChatReplyMatchSettingMutationVariables>(DisableNormalMessageChatReplyMatchSettingDocument, options);
}
export type DisableNormalMessageChatReplyMatchSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DisableNormalMessageChatReplyMatchSettingMutation, DisableNormalMessageChatReplyMatchSettingMutationVariables>;